<template>
  <div id="about" class="about-wrap style5 pt-100 pb-75">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-img-wrap">
            <img
              class="about-img-one"
              src="../../assets/images/about/about-img-11.jpg"
              alt="Image"
            />
            <img
              class="about-img-two"
              src="../../assets/images/about/about-img-12.jpg"
              alt="Image"
            />
            <div class="about-promo-text">
              <span><i class="flaticon-people"></i></span>
              <h5><span>320+</span> New Customers</h5>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-content">
            <div class="content-title style1">
              <span>Get To Know Us</span>
              <h2>Get The Best Quality Treatment For Your Eyes Care</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem has standard dummy text ever since the 1500s,
                when an unknown.
              </p>
              <h5>20+ Years Of Work Experience</h5>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a moreorless
                normal distribution of letters.
              </p>
            </div>
            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-cornea"></i>
                </div>
                <div class="feature-text">
                  <h5>Eye Health Examination</h5>
                  <p>Working on emergency treatment.</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-stethoscope"></i>
                </div>
                <div class="feature-text">
                  <h5>Laser Eye Correction</h5>
                  <p>Personal treatment and assistance.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GetToKnowUs",
};
</script>